/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $RoomStatusCounts = {
    type: 'array',
    contains: {
        type: 'RoomStatusCount',
    },
};